import React from 'react';
import { FormDrawer } from './FormDrawer';

export const UsersForm = ({
  isOpen,
  onClose,
  onSave,
  isSaving = false,
  isDarkMode = false,
  isEditing = false,
  formData,
  onChange,
  formError = '',
  roleOptions = [],
}) => {
  const sections = [
    {
      key: 'user',
      title: 'Datos del usuario',
      fields: [
        { key: 'user_code', label: 'Codigo', disabled: true, readOnly: true },
        { key: 'full_name', label: 'Nombre' },
        { key: 'email', label: 'Correo', type: 'email' },
        {
          key: 'job_title',
          label: 'Cargo',
          placeholder: 'Posición en la empresa (aparece en documentos)',
        },
        { key: 'fono', label: 'Fono' },
        {
          key: 'status',
          label: 'Estado',
          type: 'select',
          options: [
            { value: 'Activo', label: 'Activo' },
            { value: 'Inactivo', label: 'Inactivo' },
          ],
        },
        {
          key: 'role_ids',
          label: 'Roles de sistema',
          type: 'custom',
          fullWidth: true,
          render: ({ value, onChange: onFieldChange, colors, baseInputStyle }) => {
            const selected = Array.isArray(value) ? value.map(Number) : [];
            return (
              <div>
                <div style={{ fontSize: 12, marginBottom: 6 }}>Roles de sistema</div>
                <div
                  style={{
                    ...baseInputStyle,
                    height: 'auto',
                    minHeight: 36,
                    padding: '8px 10px',
                    display: 'grid',
                    gap: 6,
                  }}
                >
                  {roleOptions.length === 0 ? (
                    <span style={{ color: colors.muted, fontSize: 12 }}>
                      No hay roles disponibles.
                    </span>
                  ) : (
                    roleOptions.map((role) => {
                      const checked = selected.includes(Number(role.id));
                      return (
                        <label
                          key={role.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            fontSize: 13,
                            color: colors.inputText,
                            cursor: 'pointer',
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(event) => {
                              const id = Number(role.id);
                              if (event.target.checked) {
                                onFieldChange([...selected, id]);
                              } else {
                                onFieldChange(selected.filter((x) => x !== id));
                              }
                            }}
                          />
                          <span>
                            {role.name}
                            {role.is_system ? (
                              <span style={{ color: colors.muted, marginLeft: 6, fontSize: 11 }}>
                                (sistema)
                              </span>
                            ) : null}
                          </span>
                        </label>
                      );
                    })
                  )}
                </div>
                <div style={{ marginTop: 6, fontSize: 11, color: colors.muted }}>
                  El cargo identifica la posición laboral. Los roles controlan el acceso al sistema.
                </div>
              </div>
            );
          },
        },
      ],
    },
    {
      key: 'access',
      title: isEditing ? 'Acceso (opcional)' : 'Acceso',
      fields: [
        {
          key: 'password',
          label: isEditing ? 'Nueva contraseña' : 'Contraseña',
          type: 'password',
          placeholder: isEditing
            ? 'Dejar vacío para no cambiar'
            : 'Mínimo 8 caracteres',
        },
        {
          key: 'password_confirm',
          label: isEditing ? 'Confirmar nueva contraseña' : 'Confirmar contraseña',
          type: 'password',
          placeholder: isEditing
            ? 'Repetir solo si cambias la contraseña'
            : 'Repetir contraseña',
        },
      ],
    },
  ];

  return (
    <FormDrawer
      isOpen={isOpen}
      onClose={onClose}
      onSave={onSave}
      isSaving={isSaving}
      isDarkMode={isDarkMode}
      title={isEditing ? 'Editar Usuario' : 'Agregar Usuario'}
      subtitle={
        isEditing
          ? 'Completa la contraseña solo si quieres resetearla'
          : 'La contraseña permite iniciar sesión en la plataforma'
      }
      sections={sections}
      formData={formData}
      onChange={onChange}
      formError={formError}
      width={560}
    />
  );
};

export default UsersForm;
